// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__l-E70","row":"styles_row__TRXBc"};